/**
 * LinkSection Component
 * 
 * Displays a section of links (documentation or training resources).
 * Renders links as clickable hyperlinks with titles.
 * 
 * Requirements: 3.4, 4.4, 10.2, 10.3
 */

import React from 'react';
import { DocumentationLink, TrainingLink } from '../types';

interface LinkSectionProps {
  title: string;
  links: DocumentationLink[] | TrainingLink[];
}

export const LinkSection: React.FC<LinkSectionProps> = ({ title, links }) => {
  // Don't render the section if there are no links
  if (!links || links.length === 0) {
    return null;
  }

  return (
    <div className="link-section" role="region" aria-label={title}>
      <h3>{title}</h3>
      <ul className="link-list">
        {links.map((link, index) => (
          <li key={index} className="link-item">
            <a
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className="link"
            >
              {link.title}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};
